import type React from "react";

import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { MultiLineContent } from "@/components/MultiLineContent/MultiLineContent";
import { Button } from "@/design-system/Button";
import { useTranslation } from "@/translations";

type SocialContributionWidgetActionsModalProps = ModalBaseProps;

export function SocialContributionWidgetActionsModal({
  isOpened,
  onOpenChange,
}: SocialContributionWidgetActionsModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("component.analytics-widget.social-contribution.action-modal.title")}
      {...{ isOpened, onOpenChange }}
    >
      <Modal.Body>
        <section className="py-space-sm text-body">
          <MultiLineContent>{t("component.analytics-widget.social-contribution.action-modal.body")}</MultiLineContent>
        </section>
      </Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button>{t("common.action.close")}</Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
